import Constants from '../Constants';
import HandleAsyncError from '../errors/ErrorHandlerDecorator';

import { HttpClient } from './HttpClient';
import type {Domain} from "@zooplus/commons-lang";

export default class RewardShopService extends HttpClient {
  public metricsService: any;

  constructor(metricsService: any) {
    super();
    this.metricsService = metricsService;
  }

  @HandleAsyncError()
  async onGetRewardShopOverview(token: string | undefined, siteDomain: Domain, lang: string) {
    const arrayLocale = lang.split('_');
    const response = await super.get(
      `${Constants.API.URI.REWARD_SHOP}?siteDomain=${siteDomain}&lang=${arrayLocale[0]}`,
      token,
    );
    return response.json();
  }
}
